import { CountryCode } from '../../i18n/countryCodes'

export default function fetchDefaultTaxServices(api: GlobalFetch) {
  return async function(lang: CountryCode) {
    const buildUrl = `/api/v2/service/default/lang/${lang}`
    const response = await api.fetch(buildUrl)
    const responseBody: IData = await response.json()

    return responseBody.items[0]
  }
}

export interface IData {
  messages: string[]
  items: IDefaultServices[]
}

export interface IDefaultServices {
  name: string
  default: string
  first_tax: string
  second_tax: string
  id: string
}
